import { RootState } from '../../../../redux/store.model';

export function getFeatureToggle(state: RootState) {
  return state.featureToggle;
}
